<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container fluid>
            <v-card>
                <v-card-text>
                    <h1>Stock Transfer List</h1>
                    <!-- <v-btn @click="test"></v-btn> -->
                    <hr>
                    <v-layout>
                        <v-flex xs1 mr-2>
                            <v-menu v-model="menuMonth" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="searchMonth" label="Select Month:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="searchMonth" @input="menuMonth = false" :max="nowDate" type="month" @change="changeMonth()"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs2>
                            <v-menu v-model="menuStartDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="startDate" label="Start date:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="startDate" @input="menuStartDate = false" 
                                :max="nowDate" type="date" @change="dateFilter()"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs2 mr-2>
                            <v-menu v-model="menuEndDate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition"
                                offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="endDate" label="End date:" prepend-icon="event" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="endDate" @input="menuEndDate = false" 
                                :max="nowDate" type="date" @change="dateFilter()" :min="startDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs2 mr-2>
                            <v-select :items="itemsWarehouse" v-model="warehouse" label="Warehouse filter:" @change="warehouseFilter"></v-select>
                        </v-flex>
                        <v-flex>
                            <v-btn flat @click="resetFilter"><v-icon>refresh</v-icon>reset</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-data-table :headers="headers" :items="detail" item-key="id" class="elevation-1" :rows-per-page-items="rowsPerPageItems">
                        
                        <template v-slot:no-data>
                            <!-- <v-progress-linear v-slot:progress color="primary" indeterminate>No data available</v-progress-linear> -->
                            <v-alert class="text-center" color="info" icon="info" :value="true" outline>
                                No data found in this month
                            </v-alert>
                        </template>
                        <template v-slot:items="props" >
                                <td>{{props.item.warehouse}}</td>
                                <td>{{props.item.trNo}}</td>
                                <td>{{props.item.date}}</td>
                                <td>{{props.item.itemCode}}</td>
                                <td>{{props.item.frame}}</td>
                                <td>{{props.item.front}}</td>
                                <td>{{props.item.qc}}</td>
                                <td class="text-xs-right">{{props.item.amt.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                <td class="text-xs-left">
                                <!-- <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon small class="mr-2" v-on="on">ballot</v-icon>
                                    </template>
                                    <span>View detail</span>
                                </v-tooltip> -->
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small class="mr-2" @click="viewTransfer(props.item)" v-on="on">visibility</v-icon>
                                        </template>
                                        <span>View list details</span>
                                    </v-tooltip>
                                    
                                </td>
                            
                        </template>
                        
                    </v-data-table>

                </v-card-text>
            </v-card>

            <!-- View Detail -->
            <v-dialog v-model="showViewTransfer" max-width="1220px">
                <v-card>
                    <v-card-title class="headline">
                        <v-flex xs2>
                            View Transfer Lists
                        </v-flex>
                        <v-flex text-xs-right>
                            <v-icon @click="closeViewTransfer">clear</v-icon>
                        </v-flex>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-container>
                                        
                                <v-layout>
                                    <v-flex xs11 text-xs-right>Transfer no: </v-flex>
                                    <v-flex xs1 text-xs-right>
                                        <input type="text" class="line" v-model="trNo" disabled>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex xs11 text-xs-right>Date: </v-flex>
                                    <v-flex  xs1 text-xs-right>
                                        <input type="text" class="line" v-model="trDate" disabled>
                                    </v-flex>
                                </v-layout>


                                <!-- Add from and to warehouse transfer -->
                                <v-flex xs12 class="text-center">
                                    <span class="red--text">
                                        Transfer from {{ fromWarehouse }} to {{ warehouse }}
                                    </span>
                                </v-flex>

                                <!-- Transfer detail -->
                                <br>
                                <v-layout table>
                                    <v-flex xs1 text-xs-center><h4>No</h4></v-flex>
                                    <v-flex xs2 text-xs-center><h4>Model</h4></v-flex>
                                    <v-flex xs2 text-xs-center><h4>QC No</h4></v-flex>
                                    <v-flex xs1 text-xs-center><h4>Frame</h4></v-flex>
                                    <v-flex xs1 text-xs-center><h4>Front</h4></v-flex>
                                    <v-flex xs2 text-xs-right><h4>Warehouse</h4></v-flex>
                                    <v-flex xs2 text-xs-right><h4>Amount</h4></v-flex>
                                </v-layout>
                                <v-layout v-for="(item,i) in trDetail" :key="i" collapse tableDetail>
                                    <v-flex xs1 text-xs-center>
                                        <font size=2>{{i+1}}</font>
                                    </v-flex>
                                    <v-flex xs2 text-xs-center>
                                        <font size=2>{{item.itemCode}}</font>
                                    </v-flex>
                                    <v-flex xs2 text-xs-center>
                                        <font size=2>{{item.qc}}</font>
                                    </v-flex>
                                    <v-flex xs1 text-xs-center>
                                        <font size=2>{{item.frame}}</font>
                                    </v-flex>
                                    <v-flex xs1 text-xs-center>
                                        <font size=2>{{item.front}}</font>
                                    </v-flex>
                                    <v-flex xs2 text-xs-right>
                                        <font size=2>{{ item.warehouse }}</font>
                                    </v-flex>
                                    <v-flex xs2>
                                        <vue-numeric separator="," :precision="2" disabled :value="item.amt" class="numeric"></vue-numeric>
                                    </v-flex>
                                </v-layout>
                                <br>
                                <v-layout>
                                    <v-flex xs6>         
                                        <v-layout>
                                            <v-flex>
                                                <strong>Remark: </strong>
                                                <textarea rows="2" cols="50" class="lineShipAdd" v-model="remark" disabled></textarea>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>       
                                </v-layout>
                            </v-container>
                        </v-card-text>
                </v-card>
            </v-dialog>

            <!-- Dialog progress -->
            <v-dialog v-model="showDialog" max-width="90" persistent>
                <div class="text-xs-center">
                    <v-card>
                        <v-card-text>
                            <v-progress-circular v-if="showProgress" :size="30" color="primary" indeterminate></v-progress-circular>
                            <div v-if="showSuccess">
                                <v-icon color="green" :size="40">check_circle_outline</v-icon>
                                Success.
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </v-dialog>

        </v-container>
    </v-app>
</template>
<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
import VueNumeric from 'vue-numeric'
export default {
    components:{
        mainMenu,
        VueNumeric
    },
    data() {
        return{
            menuMonth: false,
            searchMonth: new Date().toISOString().substr(0, 7),
            nowDate: new Date().toISOString().slice(0,10),
            itemsRefNo: [],
            refNo: '',
            itemsWarehouse: [],
            warehouse: '',
            menuStartDate: false,
            startDate: new Date().toISOString().substr(0,10),
            menuEndDate: false,
            endDate: new Date().toISOString().substr(0,10),
            staDn: '',
            trNo: '',
            trDate: '',
            amt: '',
            remark: '',


            headers: [
                { text: 'Warehouse', align: 'left', value: 'warehouse' },
                { text: 'trNo', align: 'left', value: 'trNo' },
                { text: 'Date', align: 'left', value: 'date' },
                { text: 'Item code', value: 'itemCode', align: 'left' },
                { text: 'Frame color', sortable: false, align: 'left' },
                { text: 'Front color', sortable: false, align: 'left' },
                { text: 'Quality control', value: 'qc', align: 'left' },
                { text: 'Amount', sortable: false, align: 'right' },
                { text: '', sortable: false, align: 'left' },
            ],
            rowsPerPageItems: [50,100,200,500],
            detail: [],
            cloneDetail: [],
            dialogEdit: false,
            docId: '',
            qcDate: '',
            // qcDate: new Date().toISOString().substr(0,10),
            qcRefNo: '',
            qcWarehouse: '',
            qcItemCode: '',
            itemFrame: [],
            qcFrame: '',
            itemFront: [],
            trDetail: [],
            qcFront: '',
            qcNo: '',
            prodItem: [],
            dialogProd: false,
            headerProd: [
                { text: 'Product code', align: 'left', value: 'Code' },
                { text: 'Product name', align: 'left', sortable: false },
            ],
            fromWarehouse: '',
            showDialog: false,
            showProgress: false,
            showSuccess: false,
            showViewTransfer: false,
        }
    },

    methods:{   

        // Uppercase
        uppercase(){
            this.qcItemCode = this.qcItemCode.toUpperCase()
        },

        // Get info stock
        getStock(){
            let nextMonth = new Date(this.searchMonth)
            nextMonth.setMonth(nextMonth.getMonth()+1)
            nextMonth = nextMonth.toISOString().substr(0, 7)

            db.collection("transfer").where("date", ">", this.searchMonth).where("date", "<", nextMonth)
            .onSnapshot(query=>{
                this.cloneDetail = []
                this.detail = []
                this.itemsWarehouse = []
                this.itemsWarehouse.push("")
                
                
                let idCounter = 1
                // let i = 0
                query.forEach((doc)=>{
                    let data = doc.data()
                    let detailArray = data.details
                    

                    detailArray.forEach((detailItem) => {
                        this.cloneDetail.push({
                            id: 'detail_' + idCounter++,
                            //id: query.docs[i].id,
                            date: data.date, 
                            trNo: data.trNo,
                            itemCode: detailItem.itemCode,
                            frame: detailItem.frame,
                            front: detailItem.front,
                            qc: detailItem.qc,
                            amt: detailItem.amt,
                            warehouse: data.warehouse
                        })
                    })
                    // this.itemsWarehouse.push(doc.data().warehouse)
                    // i++
                    if (!this.itemsWarehouse.includes(data.warehouse)) {
                        this.itemsWarehouse.push(data.warehouse);
                    }
                    
                })
                this.detail = this.cloneDetail
                // console.log(this.detail)
            })
        },

        // Search stock by select month
        changeMonth(){
            let nextMonth = new Date(this.searchMonth)
            nextMonth.setMonth(nextMonth.getMonth()+1)
            nextMonth = nextMonth.toISOString().substr(0, 7)
            // console.log("Search Month:", this.searchMonth)
            // console.log("Next Month:", nextMonth)

            db.collection("transfer").where("date", ">", this.searchMonth).where("date", "<", nextMonth)
            .onSnapshot(query => {
                this.cloneDetail = []
                this.detail = []
                this.itemsWarehouse = []
                this.itemsWarehouse.push("")
                
                let i = 0
                query.forEach((doc)=>{
                    let data = doc.data()
                    let detailArray = data.details

                    detailArray.forEach((detailItem) => {
                        this.cloneDetail.push({
                            id: query.docs[i].id,
                            date: data.date, 
                            trNo: data.trNo,
                            itemCode: detailItem.itemCode,
                            frame: detailItem.frame,
                            front: detailItem.front,
                            qc: detailItem.qc,
                            amt: detailItem.amt,
                            warehouse: data.warehouse
                        })
                    })
                    this.itemsWarehouse.push(doc.data().warehouse)
                    i++
                })
                this.detail = this.cloneDetail
                // console.log(this.detail)
            })              
        },


        viewTransfer(item){
            db.collection("transfer").where("trNo", "==", item.trNo).get()
            .then(querySnapshot=> {
                if(querySnapshot.empty){
                    alert("Transfer No is not correct...\nPlease Try again")
                    this.$refs.trNo.focus()
                }else{
                    this.showViewTransfer = true
                    let doc = querySnapshot.docs[0].data()
                    let docId = querySnapshot.docs[0].id
                    let detailArray = doc.details

                    this.orderId = docId
                    this.trNo = doc.trNo
                    this.trDate = doc.date.substr(0, 10)
                    this.fromWarehouse = doc.details[0].fromWarehouse
                    this.warehouse = doc.warehouse

                    detailArray.forEach((detailItem) => {
                        this.trDetail.push({
                            itemCode: detailItem.itemCode,
                            frame: detailItem.frame,
                            front: detailItem.front,
                            qc: detailItem.qc,
                            amt: detailItem.amt,
                            warehouse: doc.warehouse
                        })
                        
                    })
                    this.remark = doc.remark
                }
            })
        },

        closeViewTransfer() {
            this.showViewTransfer = false
            this.trDetail = []
        
        },
        // Filter by start date and end date
        dateFilter(){
            if(this.refNo == ''){
                this.detail = this.cloneDetail.filter(rec=>rec.date >= this.startDate && rec.date <= this.endDate)
            }
            else{
                this.detail = this.cloneDetail.filter(rec=>this.refNo == rec.dnNo && rec.date >= this.startDate && rec.date <= this.endDate)
            }
        },

        // Filter by warehouse
        warehouseFilter(){
            this.refNo = ''
            this.startDate = new Date().toISOString().substr(0,10)
            this.endDate = new Date().toISOString().substr(0,10)
            this.detail = this.cloneDetail.filter(rec=>this.warehouse == rec.warehouse.slice(0,this.warehouse.length))
        },

       

        // Reset filter to the default
        resetFilter(){
            this.refNo = ''
            this.startDate = new Date().toISOString().substr(0,10)
            this.endDate = new Date().toISOString().substr(0,10)
            this.warehouse = ''
            this.staDn = ''
            this.detail = this.cloneDetail
        },

        // Get qc for fix
        getQc(item){
            if(this.itemsWarehouse.length == 0){
                db.collection("warehouse").get()
                .then(query=>{
                    query.forEach(doc=>{
                        this.itemsWarehouse.push(doc.data().code + " " + ":" + " " + doc.data().name)
                    })
                    this.itemsWarehouse.sort()
                })
            }
            if(this.itemFrame.length == 0 || this.itemFront.length == 0){
                db.collection("code").doc("color").get()
                .then(doc=>{
                    doc.data().frame.forEach(rec=>{
                        this.itemFrame.push(rec)
                    })
                    doc.data().front.forEach(rec=>{
                        this.itemFront.push(rec)
                    })
                })
            }
            this.dialogEdit = true
            this.docId = item.id
            this.qcDate = item.date
            this.qcRefNo = item.refNo
            this.qcWarehouse = item.warehouse
            this.qcItemCode = item.itemCode
            this.qcFrame = item.frame
            this.qcFront = item.front
            this.qcNo = item.qc
        },

        // Get products
        getProd(){
            db.collection("code").doc("productcode").collection("proCode").orderBy("Code")
            .startAt(this.qcItemCode).endAt(this.qcItemCode + "\uf8ff").get()
            .then(query=>{
                this.prodItem = []
                query.forEach(doc=>{
                    this.prodItem.push(doc.data())
                })
                this.dialogProd = true
            })
        },

        selectProd(item){
            this.qcItemCode = item.Code
            this.dialogProd = false
        },

        
    },
    mounted(){
        this.getStock()
    }
}
</script>
<style scoped>
.line{
    border-bottom: 1px solid black;
    text-align: right;
    width: 100%;
}
.table{
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
}
.collapse:nth-child(even){
    background-color: #dddddd;
}
.tableDetail{
    /* border-top: 1px solid black; */
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-bottom: 1px solid black;
}
.lineShipAdd{
    border-bottom: 1px solid black;
    /* text-align: right; */
    width: 100%;
}
.numeric{
    text-align: right;
    width: 100%;
}
</style>
